import { render } from "./PrestazioniPosizione.vue?vue&type=template&id=00133de8"
import script from "./PrestazioniPosizione.vue?vue&type=script&lang=js"
export * from "./PrestazioniPosizione.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__